export interface CategoryItem {
  id: string;
  name: string;
  short: string;
  desc: string;
  icon: string;
  cover: string;
  count: number;
}

export const categories: CategoryItem[] = [
  {
    id: "drama",
    name: "影视热剧",
    short: "剧集",
    desc: "热门剧集口碑速递、剧情解析与演员幕后",
    icon: "ri-film-line",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20studio%20scene%20with%20clapperboard%20and%20warm%20amber%20stage%20lights%2C%20cinematography%20behind%20the%20scenes%2C%20rich%20terracotta%20and%20cream%20tones%2C%20editorial%20magazine%20style%2C%20soft%20dramatic%20lighting&width=1200&height=750&seq=gua-cat-drama-01&orientation=landscape",
    count: 320,
  },
  {
    id: "variety",
    name: "综艺现场",
    short: "综艺",
    desc: "慢综艺、真人秀与音乐综艺的名场面观察",
    icon: "ri-mic-line",
    cover: "https://readdy.ai/api/search-image?query=lively%20television%20variety%20show%20stage%20with%20neon%20accent%20lights%20and%20studio%20audience%2C%20warm%20golden%20and%20cream%20color%20palette%2C%20editorial%20magazine%20photography%2C%20energetic%20and%20playful%20composition&width=1200&height=750&seq=gua-cat-variety-01&orientation=landscape",
    count: 286,
  },
  {
    id: "star",
    name: "明星动态",
    short: "动态",
    desc: "作品与舞台之外的明星近况与行业观察",
    icon: "ri-user-star-line",
    cover: "https://readdy.ai/api/search-image?query=elegant%20celebrity%20backstage%20portrait%20with%20soft%20warm%20key%20light%20and%20cream%20backdrop%2C%20editorial%20magazine%20fashion%20photography%2C%20terracotta%20and%20ivory%20tones%2C%20refined%20and%20timeless%20mood&width=1200&height=750&seq=gua-cat-star-01&orientation=landscape",
    count: 198,
  },
  {
    id: "music",
    name: "音乐舞台",
    short: "音乐",
    desc: "演唱会经济与华语现场音乐新趋势",
    icon: "ri-music-2-line",
    cover: "https://readdy.ai/api/search-image?query=live%20concert%20crowd%20with%20warm%20golden%20stage%20beams%20and%20silhouettes%2C%20energetic%20atmosphere%2C%20amber%20and%20cream%20color%20scheme%2C%20editorial%20photography%2C%20emotional%20and%20immersive%20mood&width=1200&height=750&seq=gua-cat-music-01&orientation=landscape",
    count: 154,
  },
  {
    id: "hot",
    name: "热点话题",
    short: "话题",
    desc: "追剧社交、二创版权与行业趋势热议",
    icon: "ri-fire-line",
    cover: "https://readdy.ai/api/search-image?query=abstract%20conversation%20and%20social%20bubbles%20in%20warm%20terracotta%20and%20cream%20illustration%20style%2C%20trending%20topics%20concept%2C%20editorial%20graphic%20art%2C%20soft%20organic%20shapes&width=1200&height=750&seq=gua-cat-hot-01&orientation=landscape",
    count: 243,
  },
];

export const categoryTabs = categories.map((c) => ({
  id: c.id,
  name: c.short,
  full: c.name,
}));